/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FaceConfigurationOffSpringDto } from "./FaceConfigurationOffSpringDto";
import { DormerMaterialViewModel } from "../UseCaseRequests/DormerMaterials/DormerMaterialViewModel";
import { DormerColorViewModel } from "./Sections/Material/DormerColorViewModel";
import { SectionFragmentType } from "../SectionFragmentType";
import { PriceCalculationStrategyDto } from "./PriceCalculationStrategyDto";
import { FrameVariation } from "../FrameVariation";
import { FrameSupportedSizeDto } from "./Sections/FrameSupportedSizeDto";
import { SectionFragmentSide } from "../SectionFragmentSide";
import { FrameOverlaysType } from "../FrameOverlaysType";
import { FrameOverlayAssemblyType } from "../FrameOverlayAssemblyType";
import { RoofTrimVariation } from "../RoofTrimVariation";
import { AreaType } from "../AreaType";

export class SectionFragmentDto extends FaceConfigurationOffSpringDto {
    id: string | null;
    tempId: string | null;
    faceId: string | null;
    copiedFromId: string | null;
    copiedFrom: SectionFragmentDto | null;
    sort: number | null;
    width: number;
    height: number;
    availableDormerMaterialIds: string[];
    availableDormerMaterials: DormerMaterialViewModel[];
    configuredDormerColorId: string | null;
    configuredDormerColor: DormerColorViewModel | null;
    sectionFragmentType: SectionFragmentType;
    priceCalculationStrategyId: string | null;
    priceCalculationStrategy: PriceCalculationStrategyDto | null;
    isDefaultForTemplate: boolean;
    minWidth: number | null;
    maxWidth: number | null;
    name: string;
    minHeight: number | null;
    maxHeight: number | null;
    variation: FrameVariation | null;
    supportedSizes: FrameSupportedSizeDto[];
    cheekSide: SectionFragmentSide | null;
    frameOverlaysType: FrameOverlaysType;
    startCoordinateX: number | null;
    endCoordinateX: number | null;
    availableDormerMaterialsSideRods: DormerMaterialViewModel[];
    availableDormerMaterialsSideRodIds: string[];
    configuredDormerColorSideRods: DormerColorViewModel | null;
    configuredDormerColorSideRodId: string | null;
    frameOverlayAssemblyType: FrameOverlayAssemblyType;
    roofTrimVariation: RoofTrimVariation;
    splinterSide: SectionFragmentSide;
    stubbedSide: SectionFragmentSide;
    modifyGroup: number | null;
    advancedModifyGroups: number | null;
    uniqueGroup: number | null;
    childSectionFragments: SectionFragmentDto[];
    childSectionFragmentsIds: string[];
    areaType: AreaType;
    layer: number;
    locationX: number;
    locationY: number;
}
